import assign from 'lodash.assign';
import moment from 'moment';
import async      from 'async';
const fetch = require('node-fetch');

function checkArray(prop) {
  return Array.isArray(prop) ? prop : [prop];
}

function convertTime(time) {
  const day = moment().format('YYYY-MM-DD');
  switch (time) {
    case 'day':
      return day;
    case 'week':
      return moment().subtract(7,'d').format('YYYY-MM-DD');
    case 'month':
      return moment().subtract(1, 'months').format('YYYY-MM-DD');
    case '6months':
    return moment().subtract(6, 'months').format('YYYY-MM-DD');
    case 'year':
      return moment().subtract(1, 'years').format('YYYY-MM-DD');
  }
}

function convertQueryObj(query) {
  let obj = {
    headline: query.headline,
    slug: query.title,
    creator: query.creator,
    modifier: query.modifier,
    create_date: query.created,
    modify_date: query.modified,
    product: query.targets,
    source: query.source,
    chart_type: query.type,
    status: query.status
  }
  if (obj.create_date === 'anytime') {
    delete obj.create_date;
  }
  if (obj.modify_date === 'anytime') {
    delete obj.modify_date;
  }
  if(Array.isArray(obj.status)){
    delete obj.status;
  }

  for (let key in obj) {
    if (obj[key] === '' || obj[key] === undefined) {
      delete obj[key]
    }
  }
  return obj;
}

function convertSortObj(prop, order) {
  const obj = {}
  switch(prop) {
    case 'DATE_CREATED':
      obj.prop = 'create_date'
      break;
    case 'DATE_MODIFIED':
      obj.prop = 'modify_date'
      break;
    case 'CREATED_BY':
      obj.prop = 'creator'
      break;
    case 'STATUS':
      obj.prop = 'status'
      break;
    case 'MODIFIED_BY':
      obj.prop = 'modifier'
      break;
    case 'TITLE':
      obj.prop = 'slug'
      break;
    default:
      obj.prop = 'modify_date'
      break;
  }
  switch(order) {
    case 'DESCENDING':
      obj.order = 'desc'
      break;
    case 'ASCENDING':
      obj.order = 'asc'
      break;
  }
  return obj;
}

function pullOutHeadlines(chart) {

  //if new way is used, function always returns an object, for the old way if no sizes were selected the function return false
  const textObj = findUniqueHeadlines(chart.chart, chart.id);
  //converting source into new way, to be able to search by source
  if(!chart.chart.source && chart.chart.data.source) {
    chart.source = chart.chart.data.source.text;
  }
  let textItemInsert = [];
  let defaultHeadline = [];
  const hasDefaultHeadline = chart.default_headline ? true : false;

  if (textObj) {
    for (let key in textObj) {
      textObj[key].map(item => {
        item.text_type = key;
        if (item.content) {
          textItemInsert.push(item);
          if (item['size'] === 'default') {
            let obj = {
              content: item.content,
              type: item.text_type
            }
            defaultHeadline.push(obj);
          }
        }
      });
    }
    if (defaultHeadline.length === 1) {
      chart.default_headline = defaultHeadline[0].content;
    }
    if (defaultHeadline.length > 1) {
      for (let x = 0; x < defaultHeadline.length; x++) {
        if (defaultHeadline[x].type === 'headline') {
          chart.default_headline = defaultHeadline[x].content;
        }
      }
    }
    if (!defaultHeadline.length) {
      chart.default_headline = 'Untitled';
    }
  }

  return {textObj, textItemInsert, hasDefaultHeadline, chart}
}

function findUniqueHeadlines(chart, id) {
  const {sizes} = chart;
  const {title, dek, subdek} = chart.data;

  let titleArr = [];
  let dekArr = [];
  let subdekArr = [];
  let helper = ['title', 'dek', 'subdek']

  function check(heading, obj){
    const titleCheck = heading === 'title';
    const dekCheck = heading === 'dek';
    const subdekCheck = heading === 'subdek';
    if(titleCheck) titleArr.push(obj);
    if(dekCheck) dekArr.push(obj);
    if(subdekCheck) subdekArr.push(obj);
  }

  //new way - no sizes
  if(title && dek && subdek){
    helper.forEach(heading => {
      const obj = {
        content: chart.data[heading].text || '',
        chart_id: id}
        check(heading, obj)
    })
  } else {
  //old way iterating over the sizes
  for (let key in sizes) {
    helper.forEach(heading=>{
      if (sizes[key].headings[heading]) {
        const obj = {
          content: sizes[key].headings[heading].text || '',
          size: key,
          chart_id: id
        };
        check(heading, obj)
      }
    })
  }

  function filterHeadings(arr){
    const contentSet = new Set();
    arr = arr.filter(elem => {
      if(contentSet.has(elem.content)) return false;
      contentSet.add(elem.content)
    })
  }

  filterHeadings(titleArr)
  filterHeadings(dekArr)
  filterHeadings(subdekArr)
}
  // adding(new way)/redefining(old way) size to default
  function addSize(arr){
    if(arr.length) arr[0]['size'] = 'default'
  }

  addSize(titleArr)
  addSize(dekArr)
  addSize(subdekArr)


  const obj = {
    headline: titleArr,
    subheadline: dekArr,
    title: subdekArr
  }

//this check required only for old (size) way, because the new way will always have length 1 for each property.
  if (obj.headline.length || obj.subheadline.length || obj.title.length) {
    return obj;
  } else {
    return false;
  }

}

function updateChartData(chart, data, action) {
  var now = new Date();
  chart.status = data.status || chart.status || 'draft';
  const prevGams = chart.urls ? chart.urls.gams : '';
  if (data.urls) {
    let urls = {};
    if (chart.urls) {
      Object.keys(chart.urls).forEach(key => {
        urls[key] = chart.urls[key];
      });
    }
    Object.keys(data.urls).forEach(key => {
      // chart['url_' + key] = data.urls[key];
      urls[key] = data.urls[key];
    });
    // if (chart.url_gams && chart.url_gamsError) {
    //   chart.url_gamsError = null;
    // }
    if (urls.gams && urls.gamsError) {
      urls.gamsError = null;
    }
    chart.urls = urls;
  }

  chart['chart_type'] = data.chart.type || chart.type;
  chart.chart = data.chart || chart.chart || {};
  chart.default_headline = data.default_headline || chart.default_headline;
  chart.slug = (data.chart && data.chart.title) ? data.chart.title : (chart.slug || '');
  chart.modifier = data.modifier || chart.modifier;
  chart.product = data.chart.product || chart.product;
  chart.version = data.version || chart.version;
  let source = '';
  if (data.chart.data.source.text.length > 0) {
    source = data.chart.data.source.text;
    const writtenSource = 'Source: '
    source = source.indexOf(writtenSource) === 0 ? source.replace(writtenSource, '') : source;
  }
  chart.source = source;
  let gamsId = 'draft';
  let imageUrl = '';
  if (data.urls) {
    if (data.urls.gams) {
      gamsId = data.urls.gams;
      // if new gamsId was not generated that means imageUrl wasn't produced
      if(gamsId===prevGams) imageUrl = '';
      else if(data.product==='marketwatch') imageUrl = data.urls.gamsUrls[5];
      else {
        imageUrl = data.urls.gamsUrls[1] || data.urls.gamsUrls[0];
      }
    }
  }
  chart.gams = gamsId || chart.gams;

  chart['modify_date'] = now;
  if (data.chart && data.chart.approved) {
    chart['approved_graphics'] = data.chart.approved.graphics;
    chart['approved_editor'] = data.chart.approved.editor;
  }
  // if (data.chart && data.chart.sections) {
  //   chart.sections = data.chart.sections;
  // }

  chart.history = data.history || chart.history || [];

  chart.history.push({
    action: action,
    user: data.modifier,
    date: now,
    imageUrl: imageUrl
  });

  if (action === 'created') {
    chart.creator = data.modifier;
    chart.id = data.id;
    chart['create_date'] = now;
    chart.modify_date = now;
  }
  return chart;
}


function pngRequest(data, environment) {
  var uri = `${converterBaseUrl(environment)}api/v1/png/string/base64/`;
  // var uri = 'http://int.prod.michelangelo-imaging.virginia.dj01.onservo.com/Rasterize/Svg?base64=true&type=png';
  // var uri = 'http://int.stg.michelangelo-imaging.virginia.dj01.onservo.com/Rasterize/Svg?base64=true&type=png'
  // const uri = `${converterBaseUrl(environment)}api/convert/base64`;
  var svgJSON = {
    "svg": sanitizeSVG(data)
  };
  return {
    method: 'POST',
    uri: uri,
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(svgJSON)
  };
}

async function epsRequest(data, environment) {
  const url = 'http://int.production.svg-converter.virginia.dj01.onservo.com/api/v1/eps/string/publish';
  return await fetch(url, {
    method: 'POST',
    uri: url,
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

function sanitizeSVG(data) {
  return data
    .replace(/\u00a0/g, " ")
    .replace(/\u0003/g, "")
    .replace('&nbsp;', " ")
    .replace(/[\x00-\x1F\x7F-\x9F]/g, "")
}

function converterBaseUrl(env) {
  if (process.env.NODE_ENV !== 'production') {
    return 'https://int-development-svg-converter.vir-dev.onservo.com/';
  } else {
    return `https://int-wsj-svg-converter.vir.onservo.com/`;
  }
}

// When returning multiple charts, returns only necessary data to display a
// table of charts and not all charts data.
function simplifyCharts(charts, query) {
  let filtered = charts;
  /* if (query.created && query.created !== 'anytime') {
    filtered = filtered.filter(chart => {
      return filterByDate(chart.createDate, query.created);
    });
  }
  if (query.modified && query.modified !== 'anytime') {
    filtered = filtered.filter(chart => {
      return filterByDate(chart.modifyDate, query.modified);
    });
  }
  if (query.title) {
    query.title = query.title.toLowerCase();
    filtered = filtered.filter(chart => {
      console.log(chart.chart.title);
      return chart.chart.title.indexOf(query.title) !== -1;
    });
  }
  if (query.text) {
    filtered = filtered.filter(chart => {
      return chartHasText(chart, query.text);
    });
  }
  if (query.creator) {
    query.creator = query.creator.toLowerCase();
    filtered = filtered.filter(chart => {
      return chart.creator.toLowerCase().indexOf(query.creator) !== -1;
    });
  }
  if (query.modifier) {
    query.modifier = query.modifier.toLowerCase();
    filtered = filtered.filter(chart => {
      return chart.modifier.toLowerCase().indexOf(query.modifier) !== -1;
    });
  }
  if (query.targets) {
    filtered = filtered.filter(chart => {
      const targets = chart.chart.targets || chart.targets;
      query.targets = Array.isArray(query.targets) ? query.targets : [query.targets];
      let found = false;
      query.targets.some(qt => {

        if (targets.indexOf(qt) !== -1) {
          console.log(qt, targets, targets.indexOf(qt) !== -1);
          return (found = true);
        }
      });
      return found;
    });
  }*/
  // const filtered = charts.filter(chart => {
  //   const targets = chart.targets || chart.chart.targets;
  //   if (query.targets && Array.isArray(targets)) {
  //     query.targets = Array.isArray(query.targets) ? query.targets : [query.targets];
  //     let found = false;
  //     // console.log(targets, query.targets);
  //     for (let i = 0; !found && i < query.targets.length; i++) {
  //       found = targets.some(target => {
  //         const targetStr = (target.indexOf('wsj') === 0) ? 'wsj' : target;
  //         return targetStr === query.targets[i];
  //       });
  //     }
  //     if (!found) {
  //       return false;
  //     }
  //   }
  //   return true;
  // });
  const simplified = filtered.map(chart => {
    let targets = chart.targets || chart.chart.targets;
    return {
      id: chart._id,
      title: chart.chart.title,
      createDate: chart.createDate,
      creator: chart.creator,
      modifyDate: chart.modifyDate || chart.createDate,
      modifier: chart.modifier || chart.creator,
      status: chart.status,
      sections: chart.chart.admin && chart.chart.admin.sections,
      targets: Array.isArray(targets) ?
        targets.sort((a, b) => {
          a = Array.isArray(a) ? a : [a];
          b = Array.isArray(b) ? b : [b];
          return sortStrs(a.join(''), b.join(''), 'asc');
        }) : [],
      approvedEditor: chart.chart.admin && chart.chart.admin.approved.editor,
      approvedGraphics: chart.chart.admin && chart.chart.admin.approved.graphics
    };
  });
  return simplified;
  // return sortCharts(simplified, query.prop, query.order);
}


function chartHasText(chart, text) {
  text = text.toLowerCase();
  if (chart.chart.title.toLowerCase().indexOf(text) !== -1) {
    return true;
  }
  if (chart.chart.data) {
    const data = chart.chart.data;
    if (data.raw && data.raw.toLowerCase().indexOf(text) !== -1) {
      return true;
    }
    if (Array.isArray(data.series)) {
      for (let i = 0; i < data.series.length; i++) {
        let name = (data.series[i].name || '') + '';
        if (name && name.toLowerCase().indexOf(text) !== -1) {
          return true;
        }
      }
    }
  }
  const keys = chart.chart.sizes ? Object.keys(chart.chart.sizes) : [];
  for (let i = 0; i < keys.length; i++) {
    let axes = chart.chart.sizes[keys[i]].axes;
    if (axes && axes.units) {
      let units = chart.chart.sizes[keys[i]].axes.units;
      if (units.prefix && units.prefix.toLowerCase().indexOf(text) !== -1) {
        return true;
      }
      if (units.suffix && units.suffix.toLowerCase().indexOf(text) !== -1) {
        return true;
      }
    }
  }
  return false;
}

function filterByDate(dateValue, relativeValue) {
  const minDate = Date.now() - getRelativeTime(relativeValue);
  return Date.parse(dateValue) >= minDate;
}

function sortStrs(a, b, order) {
  if (a < b) {
    return (order === 'desc') ? -1 : 1;
  } else if (a > b) {
    return (order === 'desc') ? 1 : -1;
  }
  return 0;
}

function buildMetadata(resp) {
  let status = '',
    hed = '',
    dek = '',
    chartTitle = '',
    inset = '',
    embed = '',
    image = '',
    publishDate = '',
    name = '',
    description = '';
  if (resp[0]) {
    const { urls, history, chart, status: statusText, slug } = resp[0];
    status = createStatus(statusText);
    const { title: hedObj, dek: dekObj, subdek: subdekObj } = chart.data;
    if (urls) {
      inset = urls.inset;
      const iframe = urls.iframe || '';
      const startIdx = iframe.indexOf('src=');
      const endIdx = iframe.indexOf('.html');
      embed = iframe.slice(startIdx + 5, endIdx + 5);
    }
    image = findImage(urls);
    const lastPublishedItem = findLastPublished(history);
    if (lastPublishedItem) publishDate = lastPublishedItem.date;
    if (hedObj) hed = hedObj.text;
    if (dekObj) dek = dekObj.text;
    if (subdekObj) chartTitle = subdekObj.text;
    name = slug || hed || dek || chartTitle;
    description = slug ?
      (hed || dek || chartTitle)
      :
      (dek || chartTitle);
  }
  return { status, hed, dek, chartTitle, inset, embed, image, publishDate, name, description };
}

function findLastPublished(history) {
  return [...history].reverse()
    .map(JSON.parse)
    .find(obj => obj.imageUrl);
} 

function createStatus(statusText) {
  return statusText[0].toUpperCase() + statusText.slice(1); 
}

function findImage(urls) {
  const gamsUrls = setGamsUrls(urls) || [];
  const searchByCrop = searchGamsUrls(gamsUrls);
  return searchByCrop('4U') || searchByCrop('PREVIEW')
    || 'https://images.wsj.net/im-108184';
}

function setGamsUrls(urls) {
  if (urls && urls.gamsUrls) {
    const { gamsUrls } = urls;
    return Array.isArray(gamsUrls) ?
      gamsUrls
      :
      [gamsUrls];
  }
}

function searchGamsUrls(gamsUrls) {
  return function(crop) {
    return gamsUrls.find(url => url.includes(crop));
  }
}

function success(res, data) {
  data.status = 'success';
  res.json(data);
  // res.json(_.assign({ status: 'success' }, data ));
}

function fail(res, data) {
  data.status = 'fail';
  res.json(data);
  // res.json(_.assign({ status: 'fail'}, data ));
}


// function filterByArray(charts, prop, value) {
//   if (!value) {
//     return charts;
//   }
//   value = Array.isArray(value) ? value : [value];
//   let filtered = [];
//   charts.forEach(chart => {
//     const chartVal = chart[prop];
//     if (chartVal) {
//       let found = false;
//       for (let i = 0; i < value.length; i++) {
//         if (chartVal.indexOf(value[i]) !== -1) {
//           found = true;
//           break;
//         }
//       }
//       if (found) filtered.push(chart);
//     }
//   });
//   return filtered;
// }
//
//
// function filterByString(charts, prop, value) {
//   if (value) {
//     let filtered = [];
//     charts.forEach(chart => {
//       const chartVal = chart[prop];
//       if (chartVal) {
//         if (chartVal.indexOf(value) !== -1) {
//           filtered.push(chart);
//         }
//       }
//     });
//     return filtered;
//   }
//   return charts;
// }


// function filterByDate(charts, prop, value) {
//   if (value && value !== 'anytime') {
//     let filtered = [];
//     const minDate = Date.now() - getRelativeTime(value);
//     charts.forEach(chart => {
//       if (Date.parse(chart[prop]) >= minDate) {
//         filtered.push(chart);
//       }
//     });
//     return filtered;
//   }
//   return charts;
// }



export {
  updateChartData,
  // getSortObj,
  // sortCharts,
  pngRequest,
  epsRequest,
  success,
  fail,
  simplifyCharts,
  findUniqueHeadlines,
  pullOutHeadlines,
  convertTime,
  convertQueryObj,
  convertSortObj,
  checkArray,
  buildMetadata,
  // filterByArray,
  // filterByString,
  // filterByDate
}


// WEBPACK FOOTER //
// ./server/shared/helpers.js